









'use strict';

var FlattenStyle={
current:function current(style){return style;},
inject:function inject(flatten){
FlattenStyle.current=flatten;
}};


module.exports=FlattenStyle;


//////////////////
// WEBPACK FOOTER
// ./~/animated/lib/injectable/FlattenStyle.js
// module id = 264
// module chunks = 0